<span class="app_name_case">{{ firstPart }}</span><span>{{ lastPart }}</span>